var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { class: ["nav", _vm.isActive ? "nav--active" : ""] },
    [
      _c("nuxt-link", { attrs: { to: "/" } }, [
        _vm.logo
          ? _c("img", { staticClass: "nav__logo", attrs: { src: _vm.logo } })
          : _vm._e()
      ]),
      _c("BaseToggler", { on: { toggleMenu: _vm.onToggleClick } }),
      _c("MenuList", {
        attrs: { links: _vm.links, modificatorClass: "menu--header" }
      }),
      !_vm.loggedIn
        ? _c("BaseBtn", {
            class: !_vm.registrationEnabled ? "btn--disabled" : "",
            attrs: { customClass: "login", text: "Увійти" },
            nativeOn: {
              click: function($event) {
                $event.preventDefault()
                return _vm.openModal($event)
              }
            }
          })
        : _vm._e(),
      _vm.loggedIn
        ? _c("BaseBtn", { attrs: { customClass: "cabinet", to: "user" } })
        : _vm._e(),
      _c(
        "BaseModal",
        {
          attrs: { opened: _vm.isOpened },
          on: {
            close: function($event) {
              _vm.isOpened = false
            }
          }
        },
        [_c("template", { slot: "body" }, [_c("AppModalWrapper")], 1)],
        2
      ),
      _c("BaseOverlay")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8f50b76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8f50b76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/TheHeader/TheNavbar.vue
// module id = YBQV
// module chunks = 4